import type { DataBindingComponentModel } from '@wix/data-binding-registry-sdk'

export const slideshow: DataBindingComponentModel = {
  componentName: 'Element_Name_Repeater',
  isConnectGfppEnabled: true,
  panel: {
    height: 525,
    title: 'slideshow_connect_panel_title',
    helpId: '80a0c763-351d-4d15-8d67-ec7c4e1f1087',
  },
  sections: [
    {
      role: 'repeaterRole',
      bindings: [],
      manifest: {
        gfpp: {
          desktop: {
            mainAction2: {
              actionId: 'repeater_live_preview_gfpp_desktop_main_action',
              label: 'Repeater_Live_Preview_GFPP_Desktop_Main_Action',
            },
          },
        },
      },
      manageContentPanel: {
        description: 'Slideshow_Manage_Content_Panel_Description',
      },
    },
  ],
  compactErrorPanel: true,
  supportsDefaultSelectedDataset: false,
}
